export default function(stringToConvert) {
  return parseFloat(
    stringToConvert
      .toString()
      .replace(",", ".")
      .replace(" ", "")
  );
}
